import React from 'react';
import {List, ListItem, ListItemIcon, ListItemText, Divider } from "@material-ui/core";
import Accessible from '@material-ui/icons/Accessible';
import AccessAlarm from '@material-ui/icons/AccessAlarm';
import EngineeringIcon from '@mui/icons-material/Engineering';
import PersonIcon from '@mui/icons-material/Person';
const MenuLista = (props) => {

  return (
    <div>
        <List component='nav'>
            
            <ListItem button  onClick={() => props.changeMenu(1)}>
                <ListItemIcon>
                    <AccessAlarm/>
                </ListItemIcon>
                <ListItemText primary='Cambiar Contraseña'/>
            </ListItem>
            <ListItem button onClick={() => props.changeMenu(2)} >
                <ListItemIcon>
                    <Accessible/>
                </ListItemIcon>
                <ListItemText primary='Historias clinicas'/>
            </ListItem>
            <Divider/>
            {props.user.rol == 'admin' ?
            <ListItem button onClick={() =>{
                props.setComeFromMenu(true);
                props.changeMenu(3);
             }} >
                <ListItemIcon>
                    <PersonIcon/>
                </ListItemIcon>
                <ListItemText primary='Afiliados'/>
            </ListItem>: ''}

            {props.user.rol == 'admin' ?
            <ListItem button onClick={() => {
                props.setComeFromMenu(true);
                props.changeMenu(4);
                }} >
                <ListItemIcon>
                    <EngineeringIcon/>
                </ListItemIcon>
                <ListItemText primary='Equipo Salud'/>
            </ListItem>: ''}

            {props.user.rol == 'admin' ?
            <ListItem button onClick={() => {
                props.setComeFromMenu(true);
                props.changeMenu(13);
                }} >
                <ListItemIcon>
                    <EngineeringIcon/>
                </ListItemIcon>
                <ListItemText primary='Asignar Pacientes'/>
            </ListItem>: ''}
        </List>
    </div>
  );
}

export default MenuLista;